import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import BalanceCheckerEditor from "../components/balance-checker-editor/BalanceCheckerEditor";

const theme = createTheme({
  palette: {
    primary: {
      main: "#27486c",
    },
  },
});

function BalanceCheckerEditorPage() {
  return (
    <ThemeProvider theme={theme}>
      <BalanceCheckerEditor />
    </ThemeProvider>
  );
}

export default BalanceCheckerEditorPage;
